import CardOpenEndedFeedback from "./CardOpenEndedFeedback";
import './CardOpenEndedFeedback.scss';

export default CardOpenEndedFeedback;